module.exports = __webpack_public_path__ + "img/arrow_down_blue.svg";